
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";

export function PaymentHistorySection() {
  return (
    <Card className="mt-6">
      <CardHeader>
        <CardTitle>Histórico de Pagamentos</CardTitle>
        <CardDescription>
          O sistema de pagamentos foi removido desta aplicação.
        </CardDescription>
      </CardHeader>
      <CardContent>
        <p className="text-muted-foreground">
          Todos os usuários têm acesso completo aos recursos da plataforma.
        </p>
      </CardContent>
    </Card>
  );
}
